import { createElement } from "react";
import React from "react";
import * as react from "react";
import { value as value_45, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { ListItemSecondaryAction, ListItemText, ListItemIcon, ListItemButton, IconButton } from "@mui/material";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import PushPin from "@mui/icons-material/PushPin";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { singleton as singleton_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";

function Components_PinButton_5E9F1DB5(components_PinButton_5E9F1DB5InputProps) {
    let elements, props_1;
    const hovered = components_PinButton_5E9F1DB5InputProps.hovered;
    const onClick = components_PinButton_5E9F1DB5InputProps.onClick;
    const isFavorite = components_PinButton_5E9F1DB5InputProps.isFavorite;
    const hovered_1 = defaultArg(hovered, false);
    return MuiHelpers_createElement(IconButton, [["className", join(" ", toList(delay(() => append(singleton("pin-button"), delay(() => (isFavorite ? singleton("enabled") : empty()))))))], ["style", createObj(toList(delay(() => append((isFavorite ? true : hovered_1) ? singleton(["opacity", 100]) : singleton(["opacity", 0]), delay(() => append(singleton(["transitionTimingFunction", "ease-in"]), delay(() => append(singleton(["transitionDuration", 100 + "ms"]), delay(() => singleton(["transitionProperty", join(",", ["opacity"])]))))))))))], ["onClick", (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        onClick();
    }], ["size", "small"], (elements = [(props_1 = {
        style: {
            width: 15 + "px",
            height: 15 + "px",
            transform: join(" ", [("rotate(" + -20) + "deg)"]),
        },
    }, react.createElement(PushPin, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

export function Components_CompanyHierarchyItem_Z538FBA19(components_CompanyHierarchyItem_Z538FBA19InputProps) {
    let elements_1;
    const sx = components_CompanyHierarchyItem_Z538FBA19InputProps.sx;
    const withChildren = components_CompanyHierarchyItem_Z538FBA19InputProps.withChildren;
    const selected = components_CompanyHierarchyItem_Z538FBA19InputProps.selected;
    const expandDisabled = components_CompanyHierarchyItem_Z538FBA19InputProps.expandDisabled;
    const onFavorite = components_CompanyHierarchyItem_Z538FBA19InputProps.onFavorite;
    const onExpand = components_CompanyHierarchyItem_Z538FBA19InputProps.onExpand;
    const onClick = components_CompanyHierarchyItem_Z538FBA19InputProps.onClick;
    const isFavorite = components_CompanyHierarchyItem_Z538FBA19InputProps.isFavorite;
    const isOpen = components_CompanyHierarchyItem_Z538FBA19InputProps.isOpen;
    const name = components_CompanyHierarchyItem_Z538FBA19InputProps.name;
    const key = components_CompanyHierarchyItem_Z538FBA19InputProps.$key;
    const expandDisabled_1 = defaultArg(expandDisabled, false);
    const selected_1 = defaultArg(selected, false);
    const withChildren_1 = defaultArg(withChildren, true);
    const patternInput = reactApi.useState(false);
    const setHovered = patternInput[1];
    return MuiHelpers_createElement(ListItemButton, [["id", key], ["className", join(" ", ["list-item"])], ["onClick", (_arg) => {
        onClick();
    }], ["onMouseEnter", (_arg_1) => {
        setHovered(true);
    }], ["onMouseLeave", (_arg_2) => {
        setHovered(false);
    }], ["dense", true], ["disableRipple", true], ["selected", selected_1], ["sx", createObj(toList(delay(() => append(singleton(["height", 35 + "px"]), delay(() => append(singleton(["padding", ((((((5 + "px ") + 10) + "px ") + 5) + "px ") + 10) + "px"]), delay(() => append(singleton(["columnGap", 10 + "px"]), delay(() => {
        const matchValue = sx;
        if (matchValue != null) {
            const styles = value_45(matchValue);
            return Object.entries(styles);
        }
        else {
            return empty();
        }
    })))))))))], (elements_1 = toList(delay(() => {
        let props_1, props_3;
        return append(withChildren_1 ? singleton(MuiHelpers_createElement(ListItemIcon, [["onClick", (ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            if (!expandDisabled_1) {
                onExpand();
            }
        }], ["sx", createObj(toList(delay(() => append(singleton(["minWidth", 0]), delay(() => (expandDisabled_1 ? append(singleton(["color", "color-mix(in srgb, var(--navy) 20%, transparent);"]), delay(() => singleton(["cursor", "auto"]))) : singleton(["color", "var(--navy)"])))))))], ["children", isOpen ? ((props_1 = {}, react.createElement(ExpandMore, props_1))) : ((props_3 = {}, react.createElement(ChevronRight, props_3)))]])) : empty(), delay(() => append(singleton(MuiHelpers_createElement(ListItemText, [["title", name], ["primaryTypographyProps", {
            noWrap: true,
            sx: {
                textOverflow: "ellipsis",
                paddingRight: 40 + "px",
            },
            variant: "body3",
        }], ["primary", name]])), delay(() => {
            let children_2;
            return singleton((children_2 = singleton_1(createElement(Components_PinButton_5E9F1DB5, {
                isFavorite: isFavorite,
                onClick: onFavorite,
                hovered: patternInput[0],
            })), MuiHelpers_createElement(ListItemSecondaryAction, [["children", reactApi.Children.toArray(Array.from(children_2))]])));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
}

